<template>
	<div class="insideBody">
		<div class="interactiveMessage" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
			<template v-if="showtask">

        <div class="taskinfo" v-for="(item,index) in tasklist" :key="index"> 
          <div class="taskheard">
            <div>
              <i></i> 任务 {{index +1}}.
            </div>
            <div>
              {{item.bookname}} > {{getStudyType(item.studytype)}} > {{getModelTypeDesc(item.modeltype)}}
            </div>
            <div>
              <span :class="getStateClass(item.state)">{{getStateDesc(item.state)}}</span>
            </div>
          </div>
          <div class="units">
            <ul>

              <li v-for="(_i,idx) in item.taskunits" :key="idx">
                <div v-if="_i.state==0"   @click="startTask(item)"> {{getUnitName(_i.unit)}}</div>
                <div v-else class="ok" > {{getUnitName(_i.unit)}}</div>
              </li>
               
            </ul>
          </div>
        </div>

			</template>
			<template v-else>
				<div class="noneImg">
					<img src="../../assets/images/none.png">
				</div>
			</template>
			<!-- <p class="noneImg" v-if="disabled && tableData.length > 0">没有更多了</p> -->
		</div>
	</div>
</template>
<script>
import {gettasklist,submittask,submittalk} from '@/api/control5'
export default {
  data(){
    return {
			textarea1: null,
			textarea2: null,
			tableData:[],
			limit: 10,
			page: 0,
			countpage: 1,
      disabled: false,
      userinfo:this.utils.storageGet("userinfo"),
      tasktimer:null,
      tasklist:[],
      showtask:false
		};
	},
	created(){
    let that = this;
    that.gettaskdata();
    
	},
	methods:{
    getUnitName(unit){
      unit = unit || "";
      let desc = "";
      if(unit.length < 4 ){
        return "UNIT " + unit
      }else{
        return unit;
      }
    },
    gettaskdata(){
      let that = this;
      let tasklist = that.utils.storageGet("tasklist");
      
      that.tasklist = tasklist;
      if(that.tasklist!=null && that.tasklist.length > 0){
        that.showtask = true;
        
      }else{
        that.showtask = false;
        
      }

      setTimeout(() => {
        that.gettaskdata();
      }, 5e3);
    },
    startTask(item){
      if(item.modeltype <= 10){
      if (this.userinfo.modules.indexOf("教材版本") > -1) {
            this.utils.storageSet("usermessage", this.userinfo);
            this.utils.storageSet("userid", this.userinfo.userid);
             window.location.href = window.location.origin + "/czy";
          } else {
            this.$message.error(
              "当前账户没有教材版本模块权限，请联系校区老师开通"
            );
            return false;
          }
      }else {
         if (this.userinfo.modules.indexOf("同步课文") > -1) {
            let umsg = this.utils.storageGet("userinfo");
            this.utils.storageSet("c-username", umsg.username);
            this.utils.storageSet("c-userid", umsg.userid);
            this.utils.storageSet("c-userphoto", "uc/" + umsg.avatar);
            window.location.href = window.location.origin + "/course";
          } else {
            this.$message.error(
              "当前账户没有同步课文模块权限，请联系校区老师开通"
            );
            return false;
          }
      }
    },
	 
    getStudyType(type){
      let desc = ""
      switch(type){
        case 1:
          desc = "学前复习";
        break;
        case 2:
          desc = "新课学习";
        break;
        case 3:
          desc = "学后复习";
        break;
      }

      return desc;
    },
    getStateDesc(state){
      let desc = ""
      switch(state){
        case 0:
          desc = "未开始";
        break;
        case 1:
          desc = "进行中";
        break;
        case 2:
          desc = "已完成";
        break;
      }

      return desc;
    },
    getStateClass(state){
      let c= "";
      if(state == 0){
        c="wks";
      }

      if(state == 2){
        c="ywc";
      }

      return c;
    },
    getModelTypeDesc(type){
var typedesc = "学习&训练";
                switch (type) {
                case 2:
                    typedesc = "单词跟读";
                    break;
                case 3:
                    typedesc = "提取复习";
                    break;
                case 4:
                    typedesc = "听写练习";
                    
                    break;
                case 5:
                    typedesc = "单元测试";
                    break;
                case 21:
                    typedesc = "课文跟读";
                    break;
                case 22:
                    typedesc = "句子听力";
                    break;
                case 23:
                    typedesc = "句子翻译";
                    break;
                case 24:
                    typedesc = "句子听写";
                    break;
                case 25:
                    typedesc = "句子默写";
                    break;
                }


                return typedesc;
    }
    
	},
	mounted(){
		
	},
	computed: {
	},
	components: {
		
  },
  destroyed(){
    clearInterval(this.tasktimer);
  }
}
</script>
<style scoped>
  .taskinfo{
    border:1px solid #000;
    margin-bottom: 0.2rem;
  }

  .taskinfo .taskheard{
    height: 0.55rem;
    line-height: 0.55rem;
    background: #eff5f5;
    color: #000;
    border-bottom: 1px solid #979b9a;
  }

  .taskinfo .taskheard >div{
    float: left;
    width: 2rem;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .taskinfo .taskheard >div:nth-child(2){
    width: calc(100% - 4.5rem);
    padding-left: 0.5rem;
    text-align: left;
  }
  .taskinfo .taskheard >div:first-child{
    background-color: #0db1a8;
    color: #fff;
    font-size: 0.20rem;
    font-weight: bold;
  }

  .taskinfo .taskheard > div:nth-child(3)>span{
    background: #ff9617;
    color: #fff;
    padding: 0.05rem 0.3rem;
    border-radius: 0.05rem;
    box-shadow: 0px 1px 5px #999;
  }

  .taskinfo .taskheard > div:nth-child(3)>span.wks{
    background: #ccc;
    box-shadow: 0px 1px 5px #999;
  }

  .taskinfo .taskheard > div:nth-child(3)>span.ywc{
    background: #0db1a8;
    box-shadow: 0px 1px 5px #999;
  }

  .taskinfo .taskheard >div > i
  {
    display: inline-block;
    height: 0.30rem;
    width: 0.25rem;
    background-image: url(../../assets/taskimg/ld.png);
    background-repeat: no-repeat;
    background-size: cover;
    margin-left: -0.4rem;
    vertical-align: sub;
  }

  .units{
        overflow: hidden;
        padding-bottom: 0.15rem;
  }

  .units >ul >li{
    float: left;
    width: 20%;
    text-align: center;

  }
  .units >ul >li > div{
    display: inline-block;
    height: 0.53rem;
    width: 1.34rem;
    background: url(../../assets/taskimg/wwc.png);
    line-height: 0.53rem;
    color: #fff;
    margin-top: 0.15rem;
    font-size: 0.18rem;
    font-weight: bold;
  }


  .units >ul >li > div:hover{
    opacity: 0.8;
    cursor: pointer;
  }

  .units >ul >li > div.ok{
    background: url(../../assets/taskimg/ywc.png);
  }

  .units >ul >li > div.ok:hover{
    opacity: 1;
    cursor: no-drop;
  }
</style>